import Signup from './Signup';

export default Signup;
